import { render, staticRenderFns } from "./audit-message.vue?vue&type=template&id=0219a207&scoped=true"
import script from "./audit-message.vue?vue&type=script&lang=js"
export * from "./audit-message.vue?vue&type=script&lang=js"
import style0 from "./audit-message.vue?vue&type=style&index=0&id=0219a207&prod&lang=scss&scoped=true"
import style1 from "./audit-message.vue?vue&type=style&index=1&id=0219a207&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0219a207",
  null
  
)

export default component.exports